import React from 'react';
import FundMe from './components/FundMe';
import './App.css';

function App() {
  return (
    <div className="App">
      <FundMe />
    </div>
  );
}

export default App;
